import { CartProductCode, MSSMemberStatus, MembershipLevel, RoleType } from '@ace-clublabs/common-membership-api-types';
import uuid4 from 'uuid4';
import CookieHelper from './cookieHelper';
import { IMemberDetails } from '../state/model';
import { getCartProductName } from '../state/helpers';
import { isGuid } from './stringHelper';
import LogCannon from '@ace-clublabs/log-cannon';

export enum UtagType {
  UDO,
  view,
  link,
}

export const ABBREVIATED_MEMBERSHIP_LEVELS = {
  [MembershipLevel.CLASSIC]: 'clsc',
  [MembershipLevel.PLUS]: 'plus',
  [MembershipLevel.PREMIER]: 'prem',
  [MembershipLevel.CLASSIC_RV]: 'clrv',
  [MembershipLevel.PLUS_RV]: 'plrv',
  [MembershipLevel.PREMIER_RV]: 'prrv',
};

const ROLE_TYPE_TAGGING_MAP = {
  [RoleType.PRIMARY]: 'primary',
  [RoleType.ADULT_ASSOCIATE]: 'associate',
  [RoleType.DEPENDENT]: 'dependent',
  [RoleType.ASSOCIATE]: 'associate',
};

export class UtagHelper {
  static loadUtagJs() {
    if ((global as any).utagLoadAttempt) return;
    (global as any).utagLoadAttempt = true;

    const utagJsScript = document.createElement('script');
    utagJsScript.src = '//tms.ace.aaa.com/ace/prod/utag.js';
    utagJsScript.type = 'text/javascript';
    utagJsScript.async = true;
    document.body.appendChild(utagJsScript);
  }

  static view(params: any) {
    (global as any).aceMediaTagValues = { ...params };
    if (typeof (global as any).utag === 'undefined') {
      UtagHelper.loadUtagJs();
    } else {
      (global as any).utag.view((global as any).aceMediaTagValues);
    }
  }

  static link(params: any) {
    (global as any).aceMediaTagValues = { ...params };
    if (typeof (global as any).utag === 'undefined') {
      UtagHelper.loadUtagJs();
    } else {
      (global as any).utag.link((global as any).aceMediaTagValues);
    }
  }

  static sendTag = (type: UtagType, tags: object | undefined, page: string, overrides?: object) => {
    const finalTags = {
      ...tags,
      ...overrides,
      page: `my account:account maintenance:replacement card${page ? `:${page}` : ''}`,
    };
    switch (type) {
      case UtagType.view:
        UtagHelper.dispatchTntSpaEvent(finalTags);
        UtagHelper.view(finalTags);
        break;
      default:
        UtagHelper.link(finalTags);
        break;
    }
  };

  static buildTags(memberDetails: IMemberDetails, overrides?: object) {
    const { members, benefitLevels, inRenewal, inArrears, loggedInCustomerId } = memberDetails || {};
    const loggedInMemberInfo = members?.find((member) => member.customerId === loggedInCustomerId);
    const state =
      loggedInMemberInfo?.residenceAddress?.state.toLowerCase() ||
      CookieHelper.getStateFromZipcodeCookie().toLowerCase();
    const getFlow = () => {
      if (inRenewal === 'Y') return 'renew';
      else if (inArrears === 'Y') return 'arrears';
      else return 'midterm';
    };
    const getRole = () => {
      return loggedInMemberInfo?.secured
        ? 'secured member'
        : loggedInMemberInfo?.roleType
        ? ROLE_TYPE_TAGGING_MAP[loggedInMemberInfo.roleType]
        : undefined;
    };
    let tags: object = {
      channel: 'my account',
      custID: memberDetails?.loggedInCustomerId,
      flow: getFlow(),
      mem_level: benefitLevels?.existingLevel.toLowerCase(),
      mem_role: getRole(),
      sessionid: LogCannon.getSessionId(),
      state: state,
      subchannel1: 'account maintenance',
      subchannel2: 'replacement card',
      ...overrides,
    };

    return tags;
  }

  // static buildConfirmationTags(
  //   memberDetails: IMemberDetails,
  //   confirmation: IGetConfirmationResponse,
  //   paymentInfo: IPaymentInfo,
  //   priceCart: IPriceCart,
  //   overrides?: object
  // ) {
  //   const {
  //     currentBenefitLevel,
  //     updatedBenefitLevel,
  //     paymentDetails,
  //     members,
  //     currentBillPlan,
  //     updatedBillPlan,
  //     confirmationId,
  //     autoPayAction,
  //     tags,
  //   } = confirmation;

  //   const benefitLevelChanged = currentBenefitLevel !== updatedBenefitLevel;
  //   const enrolledInAutopay = autoPayAction === CallbackAutoPayAction.Enroll;
  //   const productTags = this.buildProductTags(priceCart, inRenewal, inArrears, tags);
  //   const billPlanChanged = updatedBillPlan && currentBillPlan !== updatedBillPlan;

  //   const memCurrent = getIsUpgradingBenefitLevel(currentBenefitLevel!, updatedBenefitLevel!)
  //     ? `upgrade:${ABBREVIATED_MEMBERSHIP_LEVELS[updatedBenefitLevel!]}`
  //     : getIsDowngradingBenefitLevel(currentBenefitLevel!, updatedBenefitLevel!)
  //     ? `downgrade:${ABBREVIATED_MEMBERSHIP_LEVELS[updatedBenefitLevel!]}`
  //     : updatedBenefitLevel?.toLowerCase();

  //   const isMonthlyBillPlan = isOnMonthlyBillPlan(currentBillPlan as CurrentPayPlan);
  //   const isADOPastExpiration = isPastDue(termExpirationDate!);
  //   const hasPaymentDue = getAmountDue(memberDetails, paymentInfo.monthlyPaymentData, priceCart) > 0;
  //   const isADOPastDue = isADOPastExpiration && hasPaymentDue;
  //   const hasPaymentPastDue = inArrears ? true : isMonthlyBillPlan ? isMonthlyPastDue(memberDetails) : isADOPastDue;

  //   let confirmationTags = {
  //     autopay: enrolledInAutopay ? 'new' : undefined,
  //     autopayconfirmation: enrolledInAutopay ? confirmationId : undefined,
  //     confirmation_id: confirmationId,
  //     error: tags?.error,
  //     managepaymenttype: tags?.managepaymenttype,
  //     mem_autopay: isAutopayBillPlan(
  //       billPlanChanged ? (updatedBillPlan as CurrentPayPlan) : (currentBillPlan as CurrentPayPlan)
  //     ).toString(),
  //     mem_associate: members
  //       ?.filter(
  //         (m) =>
  //           (m.roleType === RoleType.ADULT_ASSOCIATE || m.roleType === RoleType.ASSOCIATE) &&
  //           m.status !== MSSMemberStatus.REMOVED
  //       )
  //       .length.toString(),
  //     mem_billplan: billPlanChanged ? updatedBillPlan?.toLowerCase() : currentBillPlan?.toLowerCase(),
  //     mem_billplan_previous: billPlanChanged ? currentBillPlan?.toLowerCase() : undefined,
  //     mem_current: memCurrent,
  //     mem_dependent: members
  //       ?.filter((m) => m.roleType === RoleType.DEPENDENT && m.status !== MSSMemberStatus.REMOVED)
  //       .length.toString(),
  //     mem_level: benefitLevelChanged ? updatedBenefitLevel?.toLowerCase() : currentBenefitLevel?.toLowerCase(),
  //     mem_previous: benefitLevelChanged ? currentBenefitLevel?.toLowerCase() : undefined,
  //     mem_status_previous: hasPaymentPastDue ? 'paymentpastdue' : undefined,
  //     page: 'my account:manage my membership:confirmation',
  //     transaction_id: this.buildTransactionId(memberDetails?.inRenewal!),
  //     transaction_type: paymentDetails?.paymentType
  //       ? PAYMENT_TRANSACTION_TAGGING_MAP[paymentDetails.paymentType] //will need to add apple and google pay once supported
  //       : undefined,
  //     ...productTags,
  //     ...overrides,
  //   };
  //   return confirmationTags;
  // }

  static buildProductTags(
    inRenewal: boolean | undefined,
    inArrears: boolean | undefined,
    confirmationTags: { [key: string]: string }
  ) {
    let productTags = {
      product: confirmationTags?.product || [],
      quantity: confirmationTags?.quantity || [],
      transaction_amount: confirmationTags?.transaction_amount || [],
      category: [],
    } as {
      product: string[];
      quantity: string[];
      transaction_amount: string[];
      category: string[];
    };

    const addProductTags = (productName: string, quantity: number, amount: number, discount: boolean = false) => {
      productTags.product.push(`${productName}${discount ? '_DISCOUNT' : ''}`); //will need to revisit logic for renewal discounts
      productTags.quantity.push(quantity.toString());
      productTags.transaction_amount.push(amount.toFixed(2));
    };

    productTags.category = productTags.category.concat(
      new Array(productTags.product.length).fill(`membership:${inRenewal || inArrears ? 'renew' : 'upgrade'}`)
    );

    return productTags;
  }

  // static getIntcmpQueryParam(currentPage: Pages, cta?: string, targetPage?: Pages) {
  //   const getPageTag = (page: Pages) => {
  //     switch (page) {
  //       case Pages.HomePage:
  //         return 'managemymembership';
  //       case Pages.ManageMembershipPage:
  //         return 'managemembership';
  //       case Pages.ContactInfoPage:
  //         return 'editmemberinfo';
  //       case Pages.ChangeBenefitLevelPage:
  //         return 'selectbenefitlevel';
  //       case Pages.MembersDetailsPage:
  //         return 'memberdetails';
  //       case Pages.AddRVMotorcycle:
  //         return 'addrv';
  //       case Pages.AssociateForm:
  //         return 'editmemberinfo';
  //       default:
  //         return 'unknown';
  //     }
  //   };
  //   let currentPageTag = currentPage ? getPageTag(currentPage) : '';
  //   let targetPageTag = targetPage ? getPageTag(targetPage) : '';

  //   const targetTag = cta ? (targetPageTag ? `${cta}${targetPageTag}` : cta) : targetPageTag;
  //   return `?intcmp=${currentPageTag}:${targetTag}`;
  // }

  static getAnalyticsSessionId() {
    const utagCookie = CookieHelper.getCookie('utag_main');
    if (utagCookie) {
      const parse = utagCookie.split('$ses_id:')[1];
      const sessionId = parse.split('%3')[0];
      return sessionId ?? '';
    }

    return '';
  }

  static buildTransactionId(inRenewal: boolean) {
    const guid = uuid4();
    const d = new Date();
    const date = `${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(
      2,
      '0'
    )}${d.getFullYear()}`;
    const prefix = inRenewal ? 'MR' : 'MU';
    return `${prefix}${date}${guid.substr(0, 12)}`;
  }

  static dispatchTntSpaEvent(tags: object) {
    document.dispatchEvent(
      new CustomEvent('tnt_spa', {
        detail: tags,
      })
    );
  }
}
